import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST } from "../services/index";

// สถานะการผูกบัญชี Telegram ของ user คนนี้ (company/user มาจาก header ใน services)
export const useTelegramStatus = () => {
  return useQuery(["telegramStatus"], async () => {
    const { result } = await GET(`/api/v1/telegram/status`);
    return result || { linked: false };
  });
};

// ขั้นที่ 1: ส่ง OTP ไปเบอร์
export const useTelegramSendCode = () => {
  return useMutation({
    mutationFn: async (phone) => await POST(`/api/v1/telegram/send-code`, { phone }),
  });
};

// ขั้นที่ 2: ยืนยัน OTP (+ 2FA ถ้ามี) — backend อาจตอบ { need2FA: true }
export const useTelegramSignIn = () => {
  return useMutation({
    mutationFn: async ({ loginId, code, password }) =>
      await POST(`/api/v1/telegram/sign-in`, { loginId, code, password }),
  });
};

// รายชื่อกลุ่มปลายทาง (เจ้า) สำหรับส่งแชท
export const useTelegramChatTargets = () => {
  return useQuery(["telegramChatTargets"], async () => {
    const { result } = await GET(`/api/v1/telegram/chat-targets`);
    return result || [];
  });
};

// ส่งรูปสลิป + ข้อความเข้ากลุ่ม
// inputId ต้องส่งไปด้วย — backend เอาไปผูก TelegramSendLog กลับหาเคส
// ไม่งั้นบันทึกได้แค่ "ส่งรูปนี้เข้ากลุ่มนี้" แต่ตอบไม่ได้ว่าเป็นสลิปของเคสไหน
export const useSendTelegramChat = () => {
  return useMutation({
    mutationFn: async ({ targetId, inputId, imageUrl, caption }) =>
      await POST(`/api/v1/telegram/send-chat`, { targetId, inputId, imageUrl, caption }),
  });
};

// ตรวจสอบสดว่า session ยังใช้ได้ (กดจากปุ่ม)
export const useTelegramVerify = () => {
  return useMutation({
    mutationFn: async () => await POST(`/api/v1/telegram/verify`, {}),
  });
};

// ยกเลิกผูกบัญชี
export const useTelegramLogout = () => {
  return useMutation({
    mutationFn: async () => await POST(`/api/v1/telegram/logout`, {}),
  });
};
